jQuery(document).ready(function($) {

 new WOW().init();

  /* ====================== NAVIGATION ======================  */
	if( $(window).width() < 1080 ) {
		 $('.menu-item-has-children').click(function(e) {
		 	$(this).find('.sub-menu').slideToggle();

		});
	}

	$('#nav-icon').click(function(){
		$(this).toggleClass('active-nav');
		$('nav').toggleClass('active-menu');
		$('body').toggleClass('disable-scroll');
	});
/* ====================== STICKY HEADER (HOME) ======================  */

$('header').waypoint(function() {
	$(this.element).toggleClass('fixed');
});

/* ====================== FILLING EFFECT (HOME) ======================  */

$('.homepage-introduction').waypoint(function() {
	$('.trade-strip').toggleClass('active');
}, {
	offset: 'bottom-in-view'
});

$('.supplier-logos').waypoint(function() {
	$('.supplier-logos').toggleClass('active');
}, {
	offset: 'bottom-in-view'
});

/* ====================== SCALE ON SCROLL ======================  */
if ( $('body' ).hasClass( "page-template-page-homepage" ) ) {
	if( $(window).width() > 767 ) {
		var contentHeight = $(".homepage-content").height();
		var controller = new ScrollMagic.Controller();

		var tween = TweenMax.to(".drop", 0.2, {height: "+=2400px"});

		var scene = new ScrollMagic.Scene({
			triggerElement: ".homepage-content", triggerHook: 'onCenter', duration: contentHeight
		})

		.setTween(tween)
		.addTo(controller);
	}
}
/* ====================== GALLERY CAROUSEL ======================  */
var owl = $('.gallery-slider');
owl.owlCarousel({
dots: false,
nav: false,
loop: true,
autoplay: true,
slideBy: 5,
autoplayTimeout:8000,
smartSpeed: 500,
responsive : {
	0 : {
		items:2
	},
	600 : {
		items:2,
	},
	900 : {
		items:3,
	},
	1140 : {
		items:4,
	},
	1500 : {
		items:5,
	}
}
})

/* ====================== HOMEPAGE TESTIMONIALS CAROUSEL ======================  */
var owl = $('.testimonials-module');
owl.owlCarousel({
dots: false,
nav: false,
loop: true,
autoplay: true,
slideBy: 1,
items: 1,
autoplayTimeout:7000,
animateIn: 'fadeIn',
animateOut: 'fadeOut',
autoHeight: true
})

/* ====================== MASTHEAD CAROUSEL ======================  */
// var owl = $('.masthead__image__slider');
// owl.owlCarousel({
// dots: false,
// nav: false,
// loop: true,
// autoplay: true,
// items: 1,
// animateOut: 'fadeOut',
// autoplayTimeout:8000,
// smartSpeed: 1000,
// touchDrag: false,
// mouseDrag: false,
// })


/* ====================== 3D SHADOW ======================  */
	$('.portrait').waypoint(function() {
		$(this.element).toggleClass('active-shadow');
	}, {
		offset: 'bottom-in-view'
	});

/* ====================== COLLECTION CAROUSEL ======================  */
	$('.bxslider').bxSlider({
		pagerCustom: '#bx-pager'
	});


/* ====================== BRANDS SECTION ======================  */
	$('.brands-inner .active').mouseenter(function() {
		var id = $(this).attr('id');

		$('.brand-overlay[data-related='+id+']').fadeIn(300);
	});

	$('.brands-inner .active').mouseleave(function() {
		var id = $(this).attr('id');

		$('.brand-overlay[data-related='+id+']').fadeOut(300);
	});

	var inst = $('[data-remodal-id=brand-modal]').remodal();

	$('.brands-inner .active').on("click", function(e) {
  	e.preventDefault();
  	var id = $(this).attr("id");
  	$('.brand-modal .remodal-inner').hide();
  	$('.brand-modal .remodal-inner[data-related="'+id+'"]').show();
  	inst.open();
  	})

  /* ====================== EX DISPLAY ITEMS  ======================  */
	var inst = $('[data-remodal-id=product-modal]').remodal();

	$('.product').on("click", function(e) {
  	e.preventDefault();
  	var id = $(this).attr("id");
  	$('.product-modal .remodal-inner').hide();
  	$('.product-modal .remodal-inner[data-related="'+id+'"]').show();
  	inst.open();
  	})

	  /* ====================== EX DISPLAY ITEMS ISOTOPE ======================  */

	  /* SET UP ISOTOPE CONTAINER
	     ======================================== */
	    var $container = $('#content .wrap');
	    var isotopePortfolio = function(filter) {
	        $container.isotope({
	            itemSelector: '.product',
	            layoutMode: 'fitRows',
	            filter: filter
	        })
	    };

	    isotopePortfolio('*');

	    /* Animate based on filter
	     ======================================== */
	    $('.filters-button-group ').on( 'click', '.button',  function(e) {
	        e.preventDefault();

	        $('.filters-button-group').find('.button').removeClass('active');
	        $(this).addClass('active');

	        var selector = $(this).attr('data-filter');
	 	isotopePortfolio(selector);
	    });

  /* ====================== SERVICES / TRADE READMORE ======================  */
	 $('a.read-more').click(function(e) {
		$(this).toggleClass('active');

		if ($(this).is('.active')) {
	    		$(this).parent().find('p:nth-of-type(n+3)').slideDown();

	    		$(this).text("< Read Less");
		}
		else {
			$('.services-content .column p:nth-of-type(n+3)').slideUp();
			$(this).text("> Read More");
		}
	});

 /* ====================== DISABLE MAP SCROLL ======================  */
	$('.acf-map').click(function () {
		$('.acf-map .gm-style').css("pointer-events", "auto");
	});

	$( ".acf-map" ).mouseleave(function() {
		$('.acf-map .gm-style').css("pointer-events", "none");
	});

/* ====================== WEBSITE NOTICE  ======================  */
  var $ = jQuery.noConflict();
  $('.website-notice__close').click(function(){
  	$('.website-notice').hide();
    $.cookie('cookie', 'true', { expires: null, path: '/' });
  });

  if ($.cookie('cookie') !== 'true'){
    $('.website-notice').addClass('website-notice--active');
  }

});
